import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import {
  updateProducts,
  uploadProducts,
} from '@/data/api/request/bulkProductsRequests';
import { isString } from '@/utils/functions';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useMassivUpload() {
  const { showSnackError, showSnackSuccess } = useSnackbarContext();

  const uploadCsvHook = useMutation<void, string, UpdateProductsArgs>({
    mutationFn: async (args: UpdateProductsArgs) => {
      switch (args.operation) {
        case CSVProductOperation.UPLOAD:
          return await uploadProducts(args.file);
        case CSVProductOperation.UPDATE:
          return await updateProducts(args.file);
        default:
          throw 'unexpected';
      }
    },
  });

  useEffect(() => {
    if (!uploadCsvHook.error) return;
    const errorMessage = isString(uploadCsvHook.error)
      ? uploadCsvHook.error
      : 'Error al cargar csv';
    showSnackError(errorMessage);
  }, [uploadCsvHook.error]);

  useEffect(() => {
    if (uploadCsvHook.isSuccess) {
      showSnackSuccess('Archivo cargado correctamente');
    }
  }, [uploadCsvHook.isSuccess]);

  return {
    uploadCsv: uploadCsvHook.mutate,
    loading: uploadCsvHook.isPending,
    success: !!uploadCsvHook.data,
  };
}

export type UpdateProductsArgs = {
  file: File;
  operation: CSVProductOperation;
};

export enum CSVProductOperation {
  UPLOAD = 'upload',
  UPDATE = 'update',
}
